import { useCallback, useMemo, useState, useEffect } from "react";
import useGetReportTimeEntries from "hooks/organization/reports/types/useGetReportTimeEntries";
import { capitalCase } from "change-case";
import JobModal from "components/JobModal/JobModal";

export default function useReportTableTimeEntries(startDate, endDate) {
  const params = {
    startDate,
    endDate,
  };

  const [getReportTimeEntries, { data, loading, error }] = useGetReportTimeEntries();

  const [openModal, setOpenModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);

  const handleOpenModal = useCallback((jobId: string) => {
    setSelectedJobId(jobId);
    setOpenModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setSelectedJobId(null);
    setOpenModal(false);
  }, []);

  const columns = useMemo(() => {
    return [
      {
        Header: "Job ID",
        accessor: "jobPhaseCostItem.jobPhase.job.id",
        Cell: ({ value }) => value || "N/A",
        filter: "includes",
        disableSortBy: true,
      },
      {
        Header: "Additional Cost Id",
        accessor: "TimeEntriesId",
        Cell: ({ value }) => value || "N/A",
        filter: "includes",
        disableSortBy: true,
      },
      {
        Header: "Additional Cost Name",
        accessor: "name",
        Cell: ({ value }) => capitalCase(value ?? "N/A"),
        disableSortBy: true,
      },
      {
        Header: "Additional Cost Quantity",
        accessor: "feeAmount",
        Cell: ({ value }) => value ?? "",
        filter: "includes",
        disableSortBy: true,
      },
      {
        Header: "Additional Cost Amount",
        accessor: "cost",
        Cell: ({ value }) => (value / 100).toFixed(2) ?? "",
        disableSortBy: true,
      },
    ];
  }, [handleOpenModal]);

  const tableData = useMemo(() => {
    return {
      columns,
      rows: data?.getReportTimeEntries?.data || [],
      modal: <JobModal jobId={selectedJobId} open={openModal} onClose={handleCloseModal} />,
    };
  }, [columns, data, selectedJobId, openModal, handleCloseModal]);

  return {
    columns,
    data,
    loading,
    error,
    tableData,
    getReportTimeEntries,
  } as const;
}
